import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';
import { t } from '../common/Translate';

const Actions = ({ actions, disabelActions, disableCta }) => {
  const { recordId } = useParams();
  const saleStatus = useSelector((state) => state.reduxRecords.data[recordId]?.trade?.sale?.sale_status?.name || '');
  const setShowExpressSale = () => {
    actions.setShowHistoryAt(false);
    actions.setShowManuelSale(false);
    if (!actions.showExpressSale) actions.setShowExpressSale(true);
  };

  const setShowManuelSale = () => {
    actions.setShowHistoryAt(false);
    actions.setShowExpressSale(false);
    if (!actions.showManuelSale) actions.setShowManuelSale(true);
  };

  // const setShowHistoryAt = () => {
  //   actions.setShowManuelSale(false);
  //   actions.setShowExpressSale(false);
  //   if (!actions.showHistoryAt) actions.setShowHistoryAt(true);
  // };

  return (
    <Container className="trade-cta-bloc">
      <Row className="mt-3 mb-3">
        <Col xs="12" sm="12" md="4">
          <Button
            color="primary"
            block
            className={
              actions.showExpressSale ||
              disabelActions ||
              saleStatus === 'winner_to_designate' ||
              saleStatus === 'closed_order_confirmed'
                ? 'btn-disabled'
                : ''
            }
            onClick={() => setShowExpressSale()}
            disabled={saleStatus === 'winner_to_designate' || saleStatus === 'closed_order_confirmed'}
          >
            {t('expressSaleCta')}
          </Button>
          <div className="subtitle mb-3 mt-1">{t('expressSaleExplanation')}</div>
        </Col>
        <Col xs="12" sm="12" md="4">
          <Button
            color="primary"
            block
            className={
              actions.showManuelSale ||
              disabelActions ||
              disableCta ||
              saleStatus === 'winner_to_designate' ||
              saleStatus === 'closed_order_confirmed'
                ? 'btn-disabled'
                : ''
            }
            onClick={() => setShowManuelSale()}
            disabled={saleStatus === 'winner_to_designate' || saleStatus === 'closed_order_confirmed'}
          >
            {t('manualSaleCta')}
          </Button>
          <div className="subtitle mt-1">{t('manualSaleExplanation')}</div>
        </Col>
        {/* <Col xs="12" sm="12" md="4"> */}
        {/*  {' '} */}
        {/*  <Button */}
        {/*    outline */}
        {/*    color="primary" */}
        {/*    block */}
        {/*    className={actions.showHistoryAt ? 'btn-disabled' : ''} */}
        {/*    onClick={() => setShowHistoryAt()} */}
        {/*  > */}
        {/*    {t('atHistoryCta')} */}
        {/*  </Button> */}
        {/*  <small className="opacity-3">{t('historyAtTabExplanation')}</small> */}
        {/* </Col> */}
      </Row>
    </Container>
  );
};

export default Actions;

Actions.propTypes = {
  disabelActions: PropTypes.bool.isRequired,
  actions: PropTypes.oneOfType([PropTypes.array]).isRequired,
  disableCta: PropTypes.bool.isRequired,
};
